<template>
  <div class="email-login-form">
    <div class="">
      <div class="left-login">
        <div class="rep-icon-login">
          <img src="../../assets/images/member-login.svg" alt="image-fluid" />
        </div>
        <div class="">
          <!-- <router-link to="/smart-login">
                  <button class="qr-login-btn">
                    <img
                        src="../../assets/images/qr-icon.svg"
                        alt="qr icon"
                        class="me-2"
                    />Login with QR
                  </button>
                </router-link> -->
        </div>
      </div>
    </div>
    <h4 class="login-title mb-2">Welcome to Member Dashboard</h4>

    <div class="auth-form pt-1 pb-3">
      <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
        <form @submit.stop.prevent="handleSubmit(checkEmailLogin)">
          <input-form-text
            :rules="{ required: true, email: true }"
            :customMessages="`Please enter your email address.`"
            :customEmailMessage="`Please enter a valid email address`"
            labelFor="Email"
            labelName="Email"
            inputName="Email"
            formGroupClass="form-group mb-1"
            placeholder="Please enter your email"
            @emitChanges="resetErrorMsg"
            :isErrorFlagSet="emailErrorFlag"
            :vmodel.sync="form.username"
          />
          <div class="valid-error" v-if="emailErrorFlag && lockoutTime <= 0">
            {{ errorMsg }}
          </div>
          <div class="left-login mb-0">
            <div></div>
            <router-link to="/forgot-email">
              <div class="login-highlight">Forgot Email?</div>
            </router-link>
          </div>
          <button :disabled="loginLoader || lockoutTime > 0" class="submit-btn mt-3 next-btn ml-0" type="submit">
            <b-spinner v-if="loginLoader" small></b-spinner>
            Next
          </button>

          <div class="login-signup-btn-wrap">
            <p>Don't have an account? <span><router-link to="/signup">Register</router-link></span></p>
          </div>
        </form>
      </ValidationObserver>
      <lockout-timer
        v-if="lockoutTime > 0"
        :lockout-seconds="lockoutTime"
        @lockout-expired="handleLockoutExpired"
      />
    </div>
  </div>
</template>

<script>
import Api from "@/resource/MemberApi";
import InputFormText from "../../components/form/InputFormText.vue";
import LockoutTimer from "./LockoutTimer"; 

export default {
  name: 'EmailLoginForm',
  components: {
    InputFormText,
    'lockout-timer': LockoutTimer
  },
  data() {
    return {
      form: { username: "", deviceID: "" },
      loginLoader: false,
      emailErrorFlag: false,
      errorMsg: '',
      lockoutTime: 0 // Tracks lockout duration from backend
    };
  },
  mounted() {
    let uniqueDeviceId = this.$store.getters.deviceId || this.$uuid.v1();
    this.form.deviceID = uniqueDeviceId;
    this.$store.commit("setDeviceId", uniqueDeviceId);
    this.$store.commit('setEnrollPrime', false);
    this.form.username = this.$store.getters.memberEmail;
  },
  methods: {
    checkEmailLogin() {
      this.loginLoader = true;
      this.$store.commit("setMemberEmail", this.form.username);
      Api.post('v4/auth/login-email-validate', {
        email: this.form.username,
        device_id: this.form.deviceID
      }).then((response) => {
        if (response.data.status === "success") {
          this.$router.push({ name: 'NewLoginPassword' });
          this.loginLoader = false;
        }
      }).catch((error) => {
        this.loginLoader = false;
        if (error.response?.status === 429) {
          const lockoutMatch = error.response.data.message?.match(/Try again after (\d+) seconds/);
          if (lockoutMatch && lockoutMatch[1]) {
            this.lockoutTime = parseInt(lockoutMatch[1], 10);
            this.emailErrorFlag = false; // Clear error flag for lockout
            this.errorMsg = ''; // Clear error message for lockout
          }
        } else {
          this.emailErrorFlag = true;
          this.errorMsg = error.response.data.message;
        }
      });
    },
    resetErrorMsg() {
      this.emailErrorFlag = false;
      this.errorMsg = '';
    },
    handleLockoutExpired() {
      this.lockoutTime = 0; // Reset lockout time when timer expires
      this.emailErrorFlag = false; // Clear error flag to hide error message
      this.errorMsg = ''; // Clear error message
    }
  }
};
</script>

<style>
.multi-step-form {
  margin: auto;
}

.multi-step-form .invalid-feedback {
  color: #E73737;
  background-color: #FFE9E9;
  border-radius: 6px;
  padding: 0.5rem 0.8rem;
  margin-top: 0.1rem;
}

.multi-step-form .step-indicator {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.multi-step-form .step-indicator span {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.multi-step-form .step-indicator span.active {
  background-color: #007bff;
  color: white;
}

.multi-step-form form {
  display: flex;
  flex-direction: column;
}

.multi-step-form label {
  margin-top: 10px;
}

.login-password-container {
  position: relative !important;
}

.login-toggle-eye-icon {
  position: absolute;
  top: 6px;
  right: 8px;
  cursor: pointer;
}

.login-password-container .is-valid {
  background-image: none !important;
}

.login-password-container .is-invalid {
  background-image: none !important;
}

.multi-step-form .login-signup-btn-wrap p {
  margin: 0;
  margin-top: 0.75rem;
  margin-right: 0.5rem;
}
</style>